export const locale = {
    lang: "es",
    data: {
        COMPONENT: {
            NoiseLevel: "Nivel de Ruido",
            Battery: "Batería",
            Octave: "Octave Spectra",
            Average5: "5 minutos promedio",
            Average30: "30 minutos promedio",
            NoData: "Sin datos aún",
            DeviceDisconnected: "Asegúrese de que el dispositivo esté conectado",
            DeviceOffline: "Dispositivo sin conexión",
            CellularSignalLevel: "Nivel Cobertura",
            FreeStorage: "Espacio Libre",
            PowerSupplyOn: "Enchufado",
            PowerSupplyOff: "En batería",
            TooltipMax: "máximo",
        },
        EVENTS: {
            Events: "Eventos",
            Severity: "Gravedad",
            Type: "Tipo",
            Device: "Dispositivo",
            StartTime: "Hora de inicio",
            EndTime: "Hora final",
            Description: "Descripción",
            Remove: "Borrar",
            ADD: "AÑADIR",
            SAVE: "GUARDAR",
            CANCEL: "CANCELAR",
            EventType: "Tipo de evento: ",
            NewEvent: "Nuevo Evento",
            EventDetail: "Detalle del evento",
            EventTimeError: "La fecha de finalización debe ser posterior a la fecha de inicio",
            Alarm: "Alarma",
            AckUser: "Aceptado por",
            Ack: "Aceptar evento",
            AckAll: "Aceptar todos los eventos coincidentes",
        },
        SEVERITY: {
            alarm: "Alarma",
            info: "información",
            success: "Ėxito",
            warning: "Advertencia",
        },
        TYPE: {
            device_alarm_off: "Alarma Apagada",
            device_alarm_on: "Alarma Activada",
            device_added: "Dispositivo Añadido",
            device_offline: "Dispositivo fuera de línea",
            device_online: "Dispositivo en línea",
            device_plugged: "Dispositivo conectado a la corriente",
            device_removed: "Dispositivo eliminado",
            device_unplugged: "Dispositivo desconectado de la corriente",
            user_defined: "Definido por el usuario",
            device_warning_off: "Advertencia desactivada",
            device_warning_on: "Advertencia activada",
            device_first_data: "Primer Dato",
        },
        ALARM: {
            ID: "Id",
            Name: "Nombre",
            Description: "Descripción",
            TimeWindow: "Ventana de tiempo",
            Threshold: "Umbral",
            Limit: "Límite",
            Severity: "Severidad",
            Field: "Campo",
            Remove: "Eliminar",
            Duplicate: "Duplicar",
            time_window_instant: "Instant",
            time_window_bucket_5: "Bucket 5 minutos",
            threshold_cross_over: "Cruzar ENCIMA",
            threshold_cross_below: "Cruzar ABAJO",
            ADD: "AÑADIR",
            SAVE: "GUARDAR",
            CANCEL: "CANCELAR",
            AlarmDetail: "Detalle de alarma",
            NewAlarm: "Nueva Alarma",
            Notify: "Notificar",
            Notification: "Notificación",
            Silent: "Silenciosa",
            NewNotificationItem: "email/teléfono",
            SimOrImei: "SIM o IMEI",
            LastCalibrationDate: "Fecha de última calibración",
            IgnoredDevices: "Dispositivos Ignorados",
        },
        FIELD: {
            sound_pressure_level: "Nivel Ruido (dBA)",
            sound_pressure_level_c: "Nivel Ruido (dBC)",
            sound_pressure_level_1m: "Nivel Ruido (dBA, 1 min)",
            sound_pressure_level_1m_sensor_2: "Sound Pressure (Sensor 2)",
            sound_pressure_level_c_1m: "Nivel Ruido (dBC, 1 min)",
            sound_pressure_level_c_minus_a: "dBC - dBA",
            rolling_5s: "Rolling 5 segundos (dBA)",
            rolling_5s_c: "Rolling 5 segundos (dBC)",
            rolling_5: "Rolling 5 minutos (dBA)",
            rolling_5_c: "Rolling 5 minutos (dBC)",
            rolling_30: "Rolling 30 minutos (dBA)",
            rolling_30_c: "Rolling 30 minutos (dBC)",
            battery: "Batería",
            power_supply_status: "Fuente Alimentación",
            spectrum_13_octave: "Espectro 1/3 Octava",
            spectrum_13_octave_1m: "Espectro 1/3 Octava (1 min)",
            temperature: "Temperatura Ext.",
            overload: "Sobrecarga",
            underrange: "Underrange",
            wifi_signal_level: "Señal WiFi",
            cellullar_signal_level: "Señal Cellular",
            free_storage: "Espacio Libre",
        },
    },
};
